class ErrorMessages {
    static ERROR_CODES = {
        ROBOT_CAPACITY_FULL: 'E001',
        IKASMAK_RAW_CAPACITY_FULL: 'E002',
        IKASMAK_TOOL_CAPACITY_FULL: 'E003',
        RAW_NOT_FOUND_IN_ALMACEN: 'E004',
        TOOL_NOT_FOUND_IN_ALMACEN: 'E005',
        RAW_NOT_FOUND_IN_ROBOT: 'E006',
        TOOL_NOT_FOUND_IN_ROBOT_FOR_IKASMAK: 'E007',
        TOOL_NOT_FOUND_IN_IKASMAK: 'E008',
        PIECE_NOT_FOUND_IN_IKASMAK: 'E009',
        PIECE_NOT_FOUND_IN_ROBOT_FOR_ALMACEN: 'E010',
        TOOL_NOT_FOUND_IN_ROBOT_FOR_ALMACEN: 'E011',
        PIECE_NOT_FOUND_FOR_MEASURE: 'E012',
        ALMACEN_CLOSED_FOR_PICKUP: 'E013',
        ALMACEN_CLOSED_FOR_PLACE: 'E014',
        IKASMAK_CLOSED_FOR_PLACE_RAW: 'E015',
        IKASMAK_CLOSED_FOR_PLACE_TOOL: 'E016',
        IKASMAK_CLOSED_FOR_PICKUP_PIECE: 'E017',
        IKASMAK_CLOSED_FOR_PICKUP_TOOL: 'E018',
        ALMACEN_ALREADY_OPEN: 'W001',
        ALMACEN_ALREADY_CLOSED: 'W002',
        IKASMAK_ALREADY_OPEN: 'W003',
        IKASMAK_ALREADY_CLOSED: 'W004',
        ROBOT_NOT_AT_IKASMAK_FOR_MACHINING: 'E019',
        ROBOT_NOT_AT_CHARGER_FOR_BATTERY: 'E020',
        ROBOT_ALREADY_AT_DESTINATION: 'W005',
        TOOL_NOT_AVAILABLE_FOR_MACHINING: 'E021',
        RAW_NOT_AVAILABLE_FOR_FIRST_MACHINING: 'E022',
        ROBOT_EMPTY_FOR_PLACE: 'E023',
        ALMACEN_EMPTY_FOR_PICKUP: 'E024',
        IKASMAK_EMPTY_FOR_PICKUP: 'E025'
    };

    static sessionErrorCounter = 0;

    static getNextErrorId() {
        this.sessionErrorCounter++;
        return this.sessionErrorCounter;
    }

    static resetSession() {
        this.sessionErrorCounter = 0;
    }

    static formatErrorWithCode(code, message) {
        const errorId = this.getNextErrorId();
        return {
            message: message,
            code: code,
            sessionId: errorId,
            logMessage: `**Error encontrado [${code}-${errorId}]**`,
            errorMessage: `[${code}-${errorId}] ${message}`
        };
    }

    static findItemInOtherLocations(itemName, currentLocation, robot, almacen, ikasmak) {
        const locations = [];
        if (currentLocation !== 'almacen' && almacen.contains.some(item => item.includes(itemName))) {
            locations.push('Almacén');
        }
        if (currentLocation !== 'robot' && robot.contains.some(item => item.includes(itemName))) {
            locations.push('Robot');
        }
        if (currentLocation !== 'ikasmak' && ikasmak.contains.some(item => item.includes(itemName))) {
            locations.push('Ikasmak');
        }
        return locations.length > 0 ? locations[0] : null;
    }

    static robotCapacityFull(current, max, itemName) {
        const message = `Error de capacidad: Robot lleno (${current}/${max}), no se puede recoger "${itemName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.ROBOT_CAPACITY_FULL, message);
    }

    static ikasmakRawCapacityFull(rawName, currentRaws, maxRaws) {
        const message = `Error de capacidad: Ikasmak sin espacio para bruto "${rawName}" (${currentRaws}/${maxRaws} ocupados)`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_RAW_CAPACITY_FULL, message);
    }

    static ikasmakToolCapacityFull(toolName, currentTools, maxTools) {
        const message = `Error de capacidad: Ikasmak sin espacio para herramienta "${toolName}" (${currentTools}/${maxTools} ocupados)`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_TOOL_CAPACITY_FULL, message);
    }

    static rawNotFoundInAlmacen(itemName, foundLocation = null) {
        let message;
        if (foundLocation) {
            message = `Error: Bruto "${itemName}" no encontrado en Almacén, pero está en ${foundLocation}`;
        } else {
            message = `Error: Bruto "${itemName}" no encontrado en Almacén`;
        }
        return this.formatErrorWithCode(this.ERROR_CODES.RAW_NOT_FOUND_IN_ALMACEN, message);
    }

    static toolNotFoundInAlmacen(itemName, foundLocation = null) {
        let message;
        if (foundLocation) {
            message = `Error: Herramienta "${itemName}" no encontrada en Almacén, pero está en ${foundLocation}`;
        } else {
            message = `Error: Herramienta "${itemName}" no encontrada en Almacén`;
        }
        return this.formatErrorWithCode(this.ERROR_CODES.TOOL_NOT_FOUND_IN_ALMACEN, message);
    }

    static rawNotFoundInRobot(foundLocation = null) {
        let message;
        if (foundLocation) {
            message = `Error: Bruto no encontrado en Robot, pero está en ${foundLocation}`;
        } else {
            message = `Error: Bruto no encontrado en Robot`;
        }
        return this.formatErrorWithCode(this.ERROR_CODES.RAW_NOT_FOUND_IN_ROBOT, message);
    }

    static toolNotFoundInRobotForIkasmak(toolName, foundLocation = null) {
        let message;
        if (foundLocation) {
            message = `Error: Herramienta "${toolName}" no encontrada en Robot, pero está en ${foundLocation}`;
        } else {
            message = `Error: Herramienta "${toolName}" no encontrada en Robot`;
        }
        return this.formatErrorWithCode(this.ERROR_CODES.TOOL_NOT_FOUND_IN_ROBOT_FOR_IKASMAK, message);
    }

    static toolNotFoundInIkasmak(toolName, foundLocation = null) {
        let message;
        if (foundLocation) {
            message = `Error: Herramienta "${toolName}" no encontrada en Ikasmak, pero está en ${foundLocation}`;
        } else {
            message = `Error: Herramienta "${toolName}" no encontrada en Ikasmak`;
        }
        return this.formatErrorWithCode(this.ERROR_CODES.TOOL_NOT_FOUND_IN_IKASMAK, message);
    }

    static pieceNotFoundInIkasmak() {
        const message = `Error: Pieza no disponible en Ikasmak`;
        return this.formatErrorWithCode(this.ERROR_CODES.PIECE_NOT_FOUND_IN_IKASMAK, message);
    }

    static pieceNotFoundInRobotForAlmacen(pieceName, inIkasmak = false) {
        let message;
        if (inIkasmak) {
            message = `Error: Pieza "${pieceName}" no encontrada en Robot, pero está en Ikasmak (currentPiece)`;
        } else {
            message = `Error: Pieza "${pieceName}" no encontrada en Robot`;
        }
        return this.formatErrorWithCode(this.ERROR_CODES.PIECE_NOT_FOUND_IN_ROBOT_FOR_ALMACEN, message);
    }

    static toolNotFoundInRobotForAlmacen(toolName, foundLocation = null) {
        let message;
        if (foundLocation) {
            message = `Error: Herramienta "${toolName}" no encontrada en Robot, pero está en ${foundLocation}`;
        } else {
            message = `Error: Herramienta "${toolName}" no encontrada en Robot`;
        }
        return this.formatErrorWithCode(this.ERROR_CODES.TOOL_NOT_FOUND_IN_ROBOT_FOR_ALMACEN, message);
    }

    static pieceNotFoundForMeasure(pieceName) {
        const message = `Error: No se ha podido medir la pieza "${pieceName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.PIECE_NOT_FOUND_FOR_MEASURE, message);
    }

    static almacenClosedForPickup(itemName) {
        const message = `Error: Almacén cerrado, no se puede recoger "${itemName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.ALMACEN_CLOSED_FOR_PICKUP, message);
    }

    static almacenClosedForPlace(itemName) {
        const message = `Error: Almacén cerrado, no se puede depositar "${itemName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.ALMACEN_CLOSED_FOR_PLACE, message);
    }

    static ikasmakClosedForPlaceRaw(rawName) {
        const message = `Error: Ikasmak cerrado, no se puede colocar bruto "${rawName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_CLOSED_FOR_PLACE_RAW, message);
    }

    static ikasmakClosedForPlaceTool(toolName) {
        const message = `Error: Ikasmak cerrado, no se puede colocar herramienta "${toolName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_CLOSED_FOR_PLACE_TOOL, message);
    }

    static ikasmakClosedForPickupPiece() {
        const message = `Error: Ikasmak cerrado, no se puede recoger pieza`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_CLOSED_FOR_PICKUP_PIECE, message);
    }

    static ikasmakClosedForPickupTool(toolName) {
        const message = `Error: Ikasmak cerrado, no se puede recoger herramienta "${toolName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_CLOSED_FOR_PICKUP_TOOL, message);
    }

    static almacenAlreadyOpen() {
        const message = `Advertencia: Almacén ya está abierto`;
        return this.formatErrorWithCode(this.ERROR_CODES.ALMACEN_ALREADY_OPEN, message);
    }

    static almacenAlreadyClosed() {
        const message = `Advertencia: Almacén ya está cerrado`;
        return this.formatErrorWithCode(this.ERROR_CODES.ALMACEN_ALREADY_CLOSED, message);
    }

    static ikasmakAlreadyOpen() {
        const message = `Advertencia: Ikasmak ya está abierto`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_ALREADY_OPEN, message);
    }

    static ikasmakAlreadyClosed() {
        const message = `Advertencia: Ikasmak ya está cerrado`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_ALREADY_CLOSED, message);
    }

    static robotNotAtIkasmakForMachining(currentLocation) {
        const message = `Error: Robot no está en Ikasmak para mecanizar (ubicación actual: ${currentLocation})`;
        return this.formatErrorWithCode(this.ERROR_CODES.ROBOT_NOT_AT_IKASMAK_FOR_MACHINING, message);
    }

    static robotNotAtChargerForBattery(currentLocation) {
        const message = `Error: Robot no está en Cargador para cargar batería (ubicación actual: ${currentLocation})`;
        return this.formatErrorWithCode(this.ERROR_CODES.ROBOT_NOT_AT_CHARGER_FOR_BATTERY, message);
    }

    static robotAlreadyAtDestination(destination) {
        const message = `Advertencia: Robot ya está en ${destination}`;
        return this.formatErrorWithCode(this.ERROR_CODES.ROBOT_ALREADY_AT_DESTINATION, message);
    }

    static toolNotAvailableForMachining(toolName) {
        const message = `Error: Herramienta "${toolName}" no disponible en Ikasmak para mecanizar`;
        return this.formatErrorWithCode(this.ERROR_CODES.TOOL_NOT_AVAILABLE_FOR_MACHINING, message);
    }

    static rawNotAvailableForFirstMachining() {
        const message = `Error: Bruto no disponible en Ikasmak para mecanizar`;
        return this.formatErrorWithCode(this.ERROR_CODES.RAW_NOT_AVAILABLE_FOR_FIRST_MACHINING, message);
    }

    static robotEmptyForPlace(entityName) {
        const message = `Error: Robot vacío, no se puede depositar en ${entityName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.ROBOT_EMPTY_FOR_PLACE, message);
    }

    static almacenEmptyForPickup(itemName) {
        const message = `Error: Almacén vacío, no se puede recoger "${itemName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.ALMACEN_EMPTY_FOR_PICKUP, message);
    }

    static ikasmakEmptyForPickup(itemName) {
        const message = `Error: Ikasmak vacío, no se puede recoger "${itemName}"`;
        return this.formatErrorWithCode(this.ERROR_CODES.IKASMAK_EMPTY_FOR_PICKUP, message);
    }
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = ErrorMessages;
}
export default ErrorMessages;
